/** True only for a login the user just made on the login screen.
 *
 *  supabase-js also fires SIGNED_IN when it restores a stored session — at
 *  cold start (possibly before getSession has resolved) and every time the
 *  app returns to the foreground. Those must not be treated as a login:
 *  MobileApp used to jump to the Estimate tab on each of them.
 *
 *  A real login happens after startup has resolved the stored login and
 *  changes who is signed in (normally from nobody). */
export function isRealSignIn(
  event: string,
  authResolved: boolean,
  prevUserId: string | null,
  nextUserId: string | null
): boolean {
  if (event !== "SIGNED_IN") return false;
  if (!authResolved) return false;
  if (!nextUserId) return false;
  return prevUserId !== nextUserId;
}
